<template>
  <div class="addWhiteIp" style="margin-top: 2%;">
    <el-row justify="center" type="flex">
      <el-col  :span="6" >
        <!--gridData.slice((currentPage-1)*pageSize,currentPage*pageSize)-->
        <el-button align="right" v-on:click="addWhiteIp" type="primary">Add White IP</el-button>
        <el-table v-loading="pieLoading"
          :data="tableData.length != 0 ? tableData.filter(data => !search || data.ipAddr.toLowerCase().includes(search.toLowerCase())) : []">
          <el-table-column prop="ipAddr" label="IP" width="180" align="center"></el-table-column>
          <el-table-column align="right">
            <template slot="header" slot-scope="scope">
              <el-input v-model="search"  placeholder="Please enter keyword search"/>
            </template>
            <template slot-scope="scope">
              <el-button  title="Edit" type="primary" icon="el-icon-edit" circle  @click="handleEdit(scope.$index,scope.row)"></el-button>
              <el-button  title="Delete" type="danger" icon="el-icon-delete" circle   @click="handleDelete(scope.$index,scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination 
          background
          layout="total,prev,pager,next"
          :total="gridData.length"
          :page-count="Math.ceil(gridData.length/pageSize)"
          :current-page.sync="currentPage"
          @current-change ="currentPageChange"
          :page-size = "pageSize">
        </el-pagination>
      </el-col>
    </el-row>
    <el-row>
      <!--<div align="center">-->
        <!--<span class="demonstration">page select</span>-->
      <!--</div>-->
      <!--<el-pagination-->
        <!--layout="prev, pager, next,jumper"-->
        <!--:page-count="pageNumber"-->
        <!--:current-page.sync="currentPage"-->
        <!--@current-change="pageChange" align="center">-->
      <!--</el-pagination>-->
    </el-row>
    <addWhiteIp v-if="isAddWhiteIp" 
    :isEdit =isEdit   
    @close = "close" 
    :editWhiteIP ="editWhiteIP" @query="query"></addWhiteIp>
  </div>
</template>

<script>
import addWhiteIp from  './addWhiteIpList'
    export default {
        name: "whiteIpList",
        components:{addWhiteIp},
        data(){
          //IP验证
          let validateIP = (rule, value, callback) => {
            var reg = /(?=(\b|\D))(((\d{1,2})|(1\d{1,2})|(2[0-4]\d)|(25[0-5]))\.){3}((\d{1,2})|(1\d{1,2})|(2[0-4]\d)|(25[0-5]))(?=(\b|\D))/
            if (value === '') {
              callback(new Error('请输入IP'));
            } else if (!reg.test(value)) {
              callback(new Error('IP不符合规范'));
            }else{
              callback();
            }
          };

          return {
            iconLoading:true,
            disabled:false,
            pieLoading:false,

            pageNumber:0,
            pageSize:8,
            currentPage:1,

            gridData: [],
            keyWords:'',
            isAddWhiteIp:false,
            addIPForm:{
              IP:''
            },
            dialogTitle:"Add White IP",
            isEdit:false,
            rules: {
              IP: [
                { validator: validateIP, trigger: 'blur' },
              ]
            },
            editWhiteIP:{},
            tableData:[],
            search:''
          }
        },
      mounted(){
          this.query();
      },
      methods:{
        addWhiteIp:function(){
          this.addIPForm.IP = "";
          this.isAddWhiteIp = true;
          this.isEdit = false;
        },
        query:function () {
          this.$axios({ 
                method:'get',
                url:'/hdars/hdars/ip/getAllWhiteIP',
                withCredentials:true
              }).then((response) => {
                if(response.data){
                  this.gridData = response.data
                  this.tableData = this.gridData.slice((this.currentPage-1)*this.pageSize,this.currentPage*this.pageSize);
                }
            })
        },
        handleEdit(index,row){
          this.dialogTitle = "Edit White IP";
          this.isEdit = true;
          this.editWhiteIP = row;
          this.isAddWhiteIp = true;
        },
        handleDelete(index,row){
           this.$confirm('Confirm to delete this IP?','Notice',{
            confirmButtonText:'Sure',
            cancelButtonText:'cancle',
            type:'warning',
            center:true
          }).then(()=>{
            this.$axios({ 
                method:'delete',
                url:'/hdars/hdars/ip/deleteWhiteIP/' + row.ipAddr
              }).then(() => {
              this.query();
            })
          })
        },
        currentPageChange:function(val){
          this.currentPage = val;
        },
        submitForm(formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              alert('submit!');
              if(this.isEdit){
                //编辑
              }else{
                //添加
              }
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
        resetForm:function() {
          this.addIPForm.IP = '';
        },
        close:function(){
          this.isAddWhiteIp = false;
        }
      }
    }

</script>

<style>
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
  .addWhiteIp .el-form-item__label{width:90px;}
  .addWhiteIp .el-form-item__content{margin-left:90px}
</style>



// WEBPACK FOOTER //
// src/page/activePublic/userManagement/whiteIpList.vue